module.exports = __webpack_public_path__ + "static/media/diningTile.794ba99b.png";